import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'moment/locale/ru'

moment.tz.setDefault('Europe/Moscow')
Vue.use(VueMoment, { moment })
